var render = function render(){var _vm=this,_c=_vm._self._c;return _c('VisitList',{attrs:{"title":"ویزیت‌های تکمیل‌نشده","status":"1"}})
}
var staticRenderFns = []

export { render, staticRenderFns }